import { render, staticRenderFns } from "./CustomLoading.vue?vue&type=template&id=15e1599c"
import script from "./CustomLoading.vue?vue&type=script&lang=js"
export * from "./CustomLoading.vue?vue&type=script&lang=js"
import style0 from "./CustomLoading.vue?vue&type=style&index=0&id=15e1599c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports